import {
  BookingLogDataType,
  loggerAction,
  loggerError,
  loggerInfo,
  loggerWarn,
} from '@collinsonx/utils/lib/analytics';
import { log } from '@lib';
import {
  ANALYTICS_TAGS,
  BookingError,
  BookingInfo,
  BookingWarn,
  DATADOG_ERROR_LOGS,
  DATADOG_INFO_LOGS,
  DATADOG_WARN_LOGS,
  PAGENAMES,
} from 'config/datadog';

export type AnalyticsFunctionProps = {
  action: ANALYTICS_TAGS;
  data?: unknown;
  page?: PAGENAMES;
};

const submitLog = process.env.NEXT_PUBLIC_DATADOG_INFOLOGS_SWITCH === 'ON';

const logToLocalConsole = (
  key: string,
  description: string,
  data?: BookingLogDataType
) => log(`${key}: ${description}`, data);

// Performance monitoring (delayed responses / timeout, delayed render, feature usage, validation errors)
export const sendInfoLog = (key: BookingInfo, data?: BookingLogDataType) => {
  logToLocalConsole(key, DATADOG_INFO_LOGS[key], data);
  if (!submitLog) return;

  loggerInfo({
    data,
    description: DATADOG_INFO_LOGS[key],
    key,
  });
};

// Non-critical/non-breaking errors (missing data, failed non-critical render, etc.)
export const sendWarnLog = (key: BookingWarn, data?: BookingLogDataType) => {
  logToLocalConsole(key, DATADOG_WARN_LOGS[key], data);
  if (!submitLog) return;

  loggerWarn({
    data,
    description: DATADOG_WARN_LOGS[key],
    key,
  });
};

// Critical errors (breaking error, failed required request, critical component failed to render, unhandled exceptions)
export const sendErrorLog = (key: BookingError, data?: BookingLogDataType) => {
  logToLocalConsole(key, DATADOG_ERROR_LOGS[key], data);
  if (!submitLog) return;

  loggerError({
    data,
    description: DATADOG_ERROR_LOGS[key],
    key,
  });
};

// User action monitoring
export const sendActionLog = (props: AnalyticsFunctionProps) => {
  if (!submitLog) return;

  loggerAction(props);
};
